/**
 * @example
 * const getRecKey = getRecKey('foo')
 * getRecKey({ foo: 'The Foo', bar: 'Le Bar }) // 'The Foo'
 */
export const getRecKey = <K extends string | number | symbol>(key: K) =>
  <T>(Record: Partial<Record<K, T>>) => Record[key]
